import React, { Fragment, useEffect, useMemo, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { changePassword, fetchUser } from "../../slices/apps/userSlice";

// utils
import logger from "../../utils/logger";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

const ChangePasswordModal = ({ id, isOpen, toggle }) => {
  const dispatch = useDispatch();

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const { user, userLoading, updateUserLoading, isUserData } = useSelector(
    (state) => {
      return {
        user: state.user.user,
        userLoading: state.user.userLoading,
        updateUserLoading: state.user.updateUserLoading,
        isUserData: state.auth.isUserData,
      };
    },
    shallowEqual
  );

  const fetchData = async () => {
    try {
      await dispatch(fetchUser(id)).unwrap();
      validation.resetForm();
    } catch (error) {
      logger.error("Failed:", error);
    }
  };

  useEffect(() => {
    if (isOpen && id) {
      fetchData();
    }
  }, [isOpen, id, dispatch]);

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      phoneNumber: user?.phoneNumber,
      oldPassword: "",
      newPassword: "",
    },

    validationSchema: Yup.object({
      oldPassword: isUserData?.role === "Admin"
        ? Yup.string().notRequired()
        : Yup.string().required("Lütfen eski şifreyi giriniz."),
      newPassword: Yup.string()
        .min(6, "Şifre en az 6 karakter olmalıdır.")
        .required("Lütfen bir şifre belirleyiniz."),
    }),

    onSubmit: async (values) => {
      await dispatch(changePassword(values)).unwrap();
      toggle(false);
    },
  });

  if (userLoading || !user) {
    return null;
  }

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className="modal-title"
        id="myLargeModalLabel"
        toggle={toggle}
      >
        Kullanıcı Şifre Değiştir
      </ModalHeader>

      <ModalBody className="p-4">
        <Form onSubmit={validation.handleSubmit} autoComplete="off">
          <Row className="gy-3">
            {isUserData?.role != "Admin" && (
              <Col lg={12}>
                <Label>Eski Şifre</Label>
                <InputGroup>
                  <span
                    className="input-group-text"
                    style={{ width: "44px" }}
                    id="inputGroupPrepend1"
                  >
                    <i
                      onClick={() => setShowOldPassword(!showOldPassword)}
                      style={{
                        cursor: "pointer",
                        color: "gray",
                      }}
                      className={
                        showNewPassword
                          ? "ri-eye-off-fill align-middle"
                          : "ri-eye-fill align-middle"
                      }
                    ></i>
                  </span>
                  <Input
                    type={showOldPassword ? "text" : "password"}
                    name="oldPassword"
                    className="form-control pe-5"
                    placeholder="******"
                    value={validation.values.oldPassword || ""}
                    onChange={validation.handleChange}
                    invalid={
                      validation.touched.oldPassword &&
                        validation.errors.oldPassword
                        ? true
                        : false
                    }
                  />
                </InputGroup>
                {validation.touched.oldPassword &&
                  validation.errors.oldPassword && (
                    <div className="invalid-feedback d-block">
                      {validation.errors.oldPassword}
                    </div>
                  )}
              </Col>
            )}
            <Col lg={12}>
              <Label>Yeni Şifre</Label>
              <InputGroup>
                <span
                  className="input-group-text"
                  style={{ width: "44px" }}
                  id="inputGroupPrepend2"
                >
                  <i
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{
                      cursor: "pointer",
                      color: "gray",
                    }}
                    className={
                      showNewPassword
                        ? "ri-eye-off-fill align-middle"
                        : "ri-eye-fill align-middle"
                    }
                  ></i>
                </span>
                <Input
                  type={showNewPassword ? "text" : "password"}
                  name="newPassword"
                  className="form-control pe-5"
                  placeholder="******"
                  value={validation.values.newPassword || ""}
                  onChange={validation.handleChange}
                  invalid={
                    validation.touched.newPassword &&
                      validation.errors.newPassword
                      ? true
                      : false
                  }
                />
              </InputGroup>
              {validation.touched.newPassword &&
                validation.errors.newPassword && (
                  <div className="invalid-feedback d-block">
                    {validation.errors.newPassword}
                  </div>
                )}
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button
              type="button"
              color="primary"
              onClick={() => validation.handleSubmit()}
              className="btn btn-label"
              disabled={updateUserLoading}
            >
              <i className="ri-check-line label-icon align-middle me-2"></i>{" "}
              Kaydet
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ChangePasswordModal;
